import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getDashboardStats = async () => {
  const res = await api.get(networkConfig.dashboard.getDashboardStats);
  return res.data;
};

export const getGamePerformance = async () => {
  return null;
  // const res = await api.get(networkConfig.dashboard.getGamePerformance);
  // return res.data;
};

export const getRevenueData = async (month = 10, year = 2025) => {
  // return null;
  const params = {};
  if (month) params.month = month;
  if (year) params.year = year;
  const res = await api.get(networkConfig.dashboard.getRevenueGrowth, {
    params,
  });
  return res.data;
};

export const getTopSellingItems = async () => {
  const res = await api.get(networkConfig.dashboard.getTopSelling);
  return res.data;
};

export const getTopSelling = async () => {
  return null;
};

export const getUserActivity = async () => {
  return null;
};
